import React, { useMemo } from 'react';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

/**
 * SeletorGE — Multi-select compartilhado de Grupos de Empresa.
 * Consumido por W-0611, W-0612, W-0614, W-0615, W-0616, W-0618, W-0621, W-0631 e outros.
 *
 * Props:
 *   grupos        {Array}    lista de {codigo_grupo_empresa, apelido}
 *   value         {Array}    codigos selecionados (int[])
 *   onChange      {Function} callback(codigos: int[])
 *   isDisabled    {boolean}  desabilita o select (default false)
 *   placeholder   {string}   placeholder customizado
 *   isMulti       {boolean}  permite múltipla seleção (default true)
 */
const SeletorGE = ({
  grupos = [],
  value = [],
  onChange,
  isDisabled = false,
  placeholder,
  isMulti = true,
}) => {
  const opcoes = useMemo(
    () => grupos.map((g) => ({
      value: g.codigo_grupo_empresa,
      label: `${g.codigo_grupo_empresa} - ${g.apelido}`,
    })),
    [grupos]
  );

  const selecionados = useMemo(() => {
    if (!isMulti) {
      return opcoes.find((o) => o.value === value) || null;
    }
    const arr = Array.isArray(value) ? value : [];
    return opcoes.filter((o) => arr.includes(o.value));
  }, [opcoes, value, isMulti]);

  const handleChange = (opts) => {
    if (!isMulti) {
      onChange(opts ? opts.value : null);
      return;
    }
    onChange(opts ? opts.map((o) => o.value) : []);
  };

  return (
    <Select
      isMulti={isMulti}
      styles={customStyles}
      components={{ DropdownIndicator }}
      options={opcoes}
      value={selecionados}
      onChange={handleChange}
      isDisabled={isDisabled}
      placeholder={placeholder || (isMulti ? 'Selecione um ou mais GEs...' : 'Selecione o GE...')}
      noOptionsMessage={() => 'Nenhum GE disponível'}
    />
  );
};

export default SeletorGE;
